import { HubConnectionState } from "@microsoft/signalr";

enum RealTimeNotificationState {
    Connected = "Connected",
    Disconnected = "Disconnected",
    Reconnecting = "Reconnecting",
    Connecting = "Connecting",
    Disconnecting = "Disconnecting"
}

function RealTimeNotificationStateFromSignalRState(signalRState: HubConnectionState): RealTimeNotificationState {
    switch (signalRState) {
        case HubConnectionState.Connected:
            return RealTimeNotificationState.Connected;
        case HubConnectionState.Disconnected:
            return RealTimeNotificationState.Disconnected;
        case HubConnectionState.Reconnecting:
            return RealTimeNotificationState.Reconnecting;
        case HubConnectionState.Connecting:
            return RealTimeNotificationState.Connecting;
        case HubConnectionState.Disconnecting:
            return RealTimeNotificationState.Disconnecting;
        default:
            return RealTimeNotificationState.Disconnected;
    }
}

export { RealTimeNotificationState, RealTimeNotificationStateFromSignalRState };
